import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { RESTAURANT_IMAGE } from '../mock/mock';
import { Users } from 'lucide-react';

const AboutUs = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={RESTAURANT_IMAGE}
              alt="Ravintola La Maria"
              className="w-full h-[420px] md:h-[520px] object-cover"
            />
          </div>
          <div className="hidden md:flex absolute -bottom-8 -right-8 w-40 h-40 rounded-xl bg-[#7A1F25] text-white items-center justify-center shadow-xl">
            <div className="text-center px-3">
              <div className="font-serif text-5xl text-[#D4A94B] font-bold leading-none">15+</div>
              <div className="text-xs tracking-[0.2em] uppercase mt-2 text-white/80">{t.about.stat1}</div>
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="inline-flex items-center gap-2 text-[#B8934A] mb-4">
            <span className="w-10 h-[1px] bg-[#B8934A]" />
            <span className="text-xs tracking-[0.3em] uppercase font-medium">Ravintola La Maria</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1F2A24] mb-6 font-semibold leading-tight">
            {t.about.heading}
          </h2>
          <div className="space-y-5 text-[#4B443C] leading-relaxed text-base md:text-lg">
            <p>{t.about.p1}</p>
            <p>{t.about.p2}</p>
            <p className="font-serif italic text-[#7A1F25]">“{t.about.p3}”</p>
            <div className="flex items-start gap-3 bg-[#FAF6F0] border border-[#EDE4D2] rounded-xl p-4">
              <Users size={22} className="text-[#7A1F25] shrink-0 mt-1" />
              <p className="text-[#4B443C] text-base leading-relaxed">{t.about.catering}</p>
            </div>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4">
            <div className="border-l-2 border-[#B8934A] pl-4">
              <div className="font-serif text-3xl md:text-4xl text-[#1F2A24] font-bold">15+</div>
              <div className="text-xs text-[#6B6257] uppercase tracking-wider mt-1">{t.about.stat1}</div>
            </div>
            <div className="border-l-2 border-[#B8934A] pl-4">
              <div className="font-serif text-3xl md:text-4xl text-[#1F2A24] font-bold">100%</div>
              <div className="text-xs text-[#6B6257] uppercase tracking-wider mt-1">{t.about.stat2}</div>
            </div>
            <div className="border-l-2 border-[#B8934A] pl-4">
              <div className="font-serif text-3xl md:text-4xl text-[#1F2A24] font-bold">200</div>
              <div className="text-xs text-[#6B6257] uppercase tracking-wider mt-1">{t.about.stat3}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
